import React from 'react';

import { DataValue } from './types';

const DataContext = React.createContext<DataValue>({
  featureData: null,
  featureLogicData: null,
  reportData: null,
  themeData: null,
  topFeatureLogics: null,
  topRaceEthnicities: null,
  topThemes: null,
  fetchFeatureLogicDataByIds: null,
  setReportData: null,
  setTopFeatureLogics: null,
  setTopRaceEthnicities: null,
  setTopThemes: null,
});

export default DataContext;
